<div class="row" > <!-- *ngIf="contractDetails" -->
    <div class="col-6">
        <h1>Contrato # {{ contractId }}</h1>
    </div>
    <div class="col-6 ">
    <div style="text-align: right" > <!--*ngIf="contractDetails.active == 1"-->
        <a [href]="fileUrl" class="btn btn-primary" download="{{ fileName }}.pdf">Descargar Contrato</a>
    </div>
    </div>
</div>

<div class="row"> <!-- *ngIf="contractDetails"-->
    <div class="col-md-4">
        <div class="card form-container">
            <form [formGroup]="contractForm">
                <!--*ngIf="contractDetails.active == 1"-->
                <div class="form-group"  *ngIf="role == 'admin'">
                    <label class="form-labels mt-4">¿Prestamo aprobado?</label><br/>
                    <div class="form-check form-check-inline mt-2">
                        <input class="form-check-input" type="radio"  value="si" formControlName="loanApproval">
                        <label class="form-check-label">Si</label>
                        </div>
                        <div class="form-check form-check-inline">
                        <input class="form-check-input" formControlName="loanApproval" type="radio" value="no">
                        <label class="form-check-label">No</label>
                    </div>
                </div>
                <div class="form-group"  *ngIf="role == 'admin'">
                    <label class="form-labels mt-4">Comentarios (Denegado/Aprobado)</label><br/>
                    <textarea class="form-control mt-2"  rows="2" formControlName="loanApprovalNotes" ></textarea> 
                </div>
                <div class="form-group">
                    <label class="form-labels mt-4">Enviar recordatorio e información por mensajes de texto</label><br/>
                    <div class="form-check form-check-inline mt-2">
                        <input class="form-check-input" type="radio"  value="si" formControlName="textMsgNotification">
                        <label class="form-check-label">Si</label>
                        </div>
                        <div class="form-check form-check-inline">
                        <input class="form-check-input" formControlName="textMsgNotification" type="radio" value="no">
                        <label class="form-check-label">No</label>
                    </div>
                </div>

                <div class="form-group">
                    <label class="form-labels mt-3">Enseñar % anual</label><br/>
                    <div class="form-check form-check-inline mt-2">
                        <input class="form-check-input" type="radio" value="si" formControlName="showAnualInterest">
                        <label class="form-check-label">Si</label>
                        </div>
                        <div class="form-check form-check-inline">
                        <input class="form-check-input" formControlName="showAnualInterest" type="radio" value="no">
                        <label class="form-check-label">No</label>
                    </div>
                </div>
                
                <div class="form-group">
                    <label class="form-labels mt-3">Pago directo</label><br/>
                    <div class="form-check form-check-inline mt-2">
                        <input class="form-check-input" type="radio" value="si" formControlName="automaticDebit" (change)="updateAutomaticDebit()">
                        <label class="form-check-label">Si</label>
                        </div>
                        <div class="form-check form-check-inline">
                        <input class="form-check-input" formControlName="automaticDebit" type="radio" value="no" (change)="updateAutomaticDebit()">
                        <label class="form-check-label">No</label>
                    </div>
                </div>

                    <div *ngIf="automaticDebitStatus">
                    <div class="form-group">
                        <label class="form-labels mt-3">Institución</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="bankInstName">
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="form-labels mt-3">Tipo de cuenta</label>
                        <select formControlName="accountType" class="form-select" (change)="updateAccountType()">
                            <option value="cheque">Cheque</option>
                            <option value="ahorro">Ahorro</option>
                            <option value="credito">Credito</option>
                        </select>
                    </div>

                    <div *ngIf="accountTypeStatus == 'cheque' || accountTypeStatus == 'ahorro'">
                        <div class="form-group">
                            <label class="form-labels mt-3">Ruta o Tránsito</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="bankInstRoutingNum">
                            </div>
                        </div>
    
                        <div class="form-group">
                            <label class="form-labels mt-3"># de cuenta</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="accountNumber">
                            </div>
                        </div>
                    </div>

                    <div *ngIf="accountTypeStatus == 'credito'">
                        <div class="form-group">
                            <label class="form-labels mt-3">Tipo de tarjeta</label>
                            <select formControlName="cardType" class="form-select">
                                <option value="Visa">Visa</option>
                                <option value="Master Card">Master Card</option>
                                <option value="American Express">American Express</option>
                                <option value="Discover">Discover</option>
                                <option value="Diners">Diners</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label class="form-labels mt-3"># de tarjeta</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="cardNumber">
                            </div>
                        </div>
    
                        <div class="form-group">
                            <label class="form-labels mt-3">Fecha de expiración</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="cardExp" [brmasker]="{mask: '00 / 0000', type:'num'}" maxlength="9">
                            </div>
                        </div> 
                    </div>

                     
                </div>
                
            </form>
            <div class="card-body" style="text-align: center;" *ngIf="contractDetails">

                
                <button [disabled]="contractDetails.paid" type="button" class="btn btn-secondary" (click)="contractRefresh()" >
                    <span style="font-size: 25px; line-height: 20px;">⟳</span> Actualizar
                </button>
                <hr/>
                <button type="button" [disabled]="contractDetails.paid" class="btn btn-info" (click)="editContract()">Editar contrato</button>
                <app-cancel-loan-contract [contractData]="contractDetails"></app-cancel-loan-contract>
                <app-delete-loan-contract [contractData]="contractDetails"></app-delete-loan-contract> 
                <app-paid-loan-contract [contractData]="contractDetails"></app-paid-loan-contract>
                <app-completed-loan [contractData]="contractDetails"></app-completed-loan>

                <app-cierre-doc [data]="cierreData" ></app-cierre-doc>
                

            </div>
        </div>
    </div>
    <div class="col-md-8">
        <div class="card">
            <div class="card-body">
                <div class="language-selector" *ngIf="!publicFormData">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="es" checked [(ngModel)]="language" (change)="updateLanguage($event)">
                        <label class="form-check-label" for="exampleRadios1" >
                          Español
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="en" [(ngModel)]="language" (change)="updateLanguage($event)">
                        <label class="form-check-label" for="exampleRadios2">
                          Ingles
                        </label>
                      </div>
                </div>
                
                <pdf-viewer *ngIf="!publicFormData" id="pdf-preview" [original-size]="false" [fit-to-page]="true"  [src]="pdfView" ></pdf-viewer>

                <div *ngIf="publicFormData">
                    <h4 class="mt-2">Solicitud de Prestamo</h4>
                    <p><strong>Nombre Completo: </strong> {{this.contractDetails.solicitante.name}}</p>
                    <p><strong>Email: </strong> {{this.contractDetails.solicitante.email}}</p>
                    <p><strong>Teléfono: </strong> {{this.contractDetails.solicitante.address.celPhone}}</p>
                    <p><strong>Cantidad de su préstamo: </strong> {{this.contractDetails.cantidad}}</p>
                    <p><strong>Tipo de Financiamiento: </strong> {{this.contractDetails.loanType}}</p>
                    <hr>
                    <p><strong>Propósito: </strong> {{this.contractDetails.proposito}}</p>
                    <p><strong>Seguro Social: </strong> {{this.contractDetails.solicitante.ss}}</p>
                    <p><strong>Número de Licencia: </strong> {{this.contractDetails.solicitante.licence}}</p>
                    <p><strong>Fecha de Nacimiento: </strong> {{this.contractDetails.solicitante.birthDate | date}}</p>
                    <p><strong>Estado Civil: </strong> {{this.contractDetails.solicitante.civilStatus}}</p>
                    <p><strong>Número de Dependientes: </strong> {{this.contractDetails.solicitante.dependientes}}</p>
                    <p><strong>¿Es codeudor o garantizador de esta financiera?: </strong> {{this.contractDetails.solicitante.isCodeudor}}</p>
                    <p><strong>Pago Mensual / Casa: </strong> {{this.contractDetails.solicitante.housePayment | currency }}</p>
                    <p><strong>Años en Residencia: </strong> {{this.contractDetails.solicitante.yearsInHouse }}</p>
                    <p><strong>Otro número: </strong> {{this.contractDetails.solicitante.civilStatus | date}}</p>
                    <p><strong>Dirección Fisica: </strong> {{this.contractDetails.solicitante.address.physicalAddress1}}, {{this.contractDetails.solicitante.address.physicalAddress2}}, {{this.contractDetails.solicitante.address.physicalCity}} {{this.contractDetails.solicitante.address.physicalState}} {{this.contractDetails.solicitante.address.physicalZip}} </p>
                    <p><strong>Dirección Postal: </strong> {{this.contractDetails.solicitante.address.postalAddress1}}, {{this.contractDetails.solicitante.address.postalAddress2}}, {{this.contractDetails.solicitante.address.postalCity}} {{this.contractDetails.solicitante.address.postalState}} {{this.contractDetails.solicitante.address.postalZip}}</p>
                    <p><strong>Nombre del Patrono: </strong> {{this.contractDetails.solicitante.employer.employerName }}</p>
                    <p><strong>Años de Empleo: </strong> {{this.contractDetails.solicitante.employer.employeedYears }}</p>
                    <p><strong>Posición o Título: </strong> {{this.contractDetails.solicitante.employer.position}}</p>
                    <p><strong>Teléfono: </strong> {{this.contractDetails.solicitante.employer.employeerPhone }}</p>
                    <p><strong>Dirección del Patrono: </strong> {{this.contractDetails.solicitante.employer.employeerAddress}}</p>
                    <p><strong>Supervisor: </strong> {{this.contractDetails.solicitante.employer.employeerSupervisor }}</p>
                    <p><strong>Ingreso Mensual: </strong> {{this.contractDetails.solicitante.employer.monthlyIncome }}</p>
                    <p><strong>Otro Ingresos: Descripción: </strong> {{this.contractDetails.solicitante.employer.otherIncomeDesc }}</p>
                    <p><strong>Otro Ingresos: Cantidad: </strong> {{this.contractDetails.solicitante.employer.otherIncomeAmount | currency }}</p>
                    <p><strong>¿Como se enteró?: </strong> {{this.contractDetails.comoSeEntero}}</p>

                </div>
            </div>
        </div>
    </div>
</div>

  <div class="row">
    <div class="col-md-12">
        <app-amortization-table [contractDetails]="contractDetails"></app-amortization-table>
        
    </div>
  </div>

  <div class="row mt-4" *ngIf="contractDetails" > <!---->
    <div class="col-md-12" *ngIf="role == 'admin' && contractDetails.active != 0"> <!---->
      <div class="card">
        <div class="card-header">
            <div class="row align-items-center card-header">
                <div class="col-6">
                    <h5>Notas</h5>
                </div>
                <div class="col-6">
                    <div style="text-align: right">
                        <a  class="btn btn-primary" (click)="updateNotes()" >Guardar</a> <!---->
                    </div>
                </div>
            </div>
            
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <textarea class="form-control"  rows="5" [(ngModel)]="notes" ></textarea> <!---->
                </div>
            </div>
        </div>
      </div>
    </div>
   </div>
  <!-- <app-edit-payment [installmentData]="installmentEdit"></app-edit-payment> -->
